/* Component Dependencies */
var PubSub = require('libs/pub-sub');
var searchForm = require('../../libs/searchFormHorizontal-lib');
var OfferNextGenHubTemplate = require('templates/offerNextGenHub.hbs');
var offerNextGenEditSearchTemplate = require('templates/offerNextGenEditSearch.hbs');
var offerNextGenMpoSearchTemplate = require('templates/offerNextGenMpoSearch.hbs');

PubSub.register(searchForm.extend({
  type: 'offerNextGenSearch',
  template: {
    'offerNextGenHub' : OfferNextGenHubTemplate,
    'offerNextGenEditSearch' : offerNextGenEditSearchTemplate,
    'offerNextGenMpoSearch': offerNextGenMpoSearchTemplate
  }
}));